import React from "react";

const NotFound = () => {
  return (
    <div className="text-center py-5">
      <h1>404</h1>
      <h3>Page Not Found</h3>
      <p>The page you're looking for doesn't exist.</p>
    </div>
  );
};

export default NotFound;
